<!--  -->
<template>
  <div>
    <el-form
      :label-position="labelPosition"
      label-width="100px"
    >
      <el-form-item label="标题">
        <el-input
          v-model="title"
          class="insedswr"
        />
      </el-form-item>
      <el-form-item label="跳转地址">
        <div class="linkfw">
          <div
            v-for="item,index in linkarr"
            :key="index"
          >
            <el-input
              v-model.trim="item.link"
              class="insedswr"
              style="margin-bottom: 10px;"
            />
            <el-button
              style="margin-left: 10px;"
              type="primary"
              size="mini"
              @click="copr(1)"
            >新增</el-button>
            <el-button
              v-if="linkarr.length!==1"
              type="danger"
              size="mini"
              @click="delterr(index,1)"
            >删除</el-button>
          </div>
        </div>

      </el-form-item>
      <el-form-item label="屏蔽地址">
        <div class="linkfw">
          <div
            v-for="item,index in shield_secondary_url"
            :key="index"
          >
            <el-input
              v-model.trim="item.link"
              class="insedswr"
              style="margin-bottom: 10px;"
            />
            <el-button
              style="margin-left: 10px;"
              type="primary"
              size="mini"
              @click="copr(2)"
            >新增</el-button>
            <el-button
              v-if="shield_secondary_url.length!==1"
              type="warning"
              size="mini"
              @click="delterr(index,2)"
            >删除</el-button>
          </div>
        </div>

      </el-form-item>
      <el-form-item label="屏蔽城市">
        <div class="linkfw">
          <el-tree
            ref="tree"
            :data="address"
            show-checkbox
            node-key="label"
            highlight-current
            :props="defaultProps"
            :check-on-click-node="true"
            @check-change="handleCheckChange"
          />
        </div>

      </el-form-item>
      <el-form-item>
        <el-button
          type="success"
          size="mini"
          @click="sumbit"
        >确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { secondaryJumpcreate, secondaryJumpupdate } from '@/api/bserw.js'
import { city_data } from '@/utils/address.js'
export default {
  components: {},
  data() {
    return {
      type: null,
      labelPosition: 'right',
      title: '',
      linkarr: [
        {
          link: ''
        }
      ],
      shield_secondary_url: [
        {
          link: ''
        }
      ],
      selectedNodes: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      loadselect: false,
      address: city_data() || [],
      chaunlinkarr: [],
      id: null
    }
  },
  created() {
    // console.log(this.address)
  },
  mounted() {},

  methods: {
    async handleCheckChange(data, checked, indeterminate) {
      this.loadselect = true
      if (checked) {
        if (data.children) {
          this.selectedNodes.push(...data.children.map(e => e.label))
        } else {
          this.selectedNodes.push(data.label)
        }
        // 选中
      } else {
        console.log('indeterminate:', indeterminate, data)
        if (data.children && indeterminate !== true) {
          this.selectedNodes = this.selectedNodes.filter(child => !data.children.some(node => node.label === child))
        } else {
          this.selectedNodes = this.selectedNodes.filter(e => e !== data.label)
        }
        // 取消
      }
      this.selectedNodes = [...new Set(this.selectedNodes)]
    },
    send(type, item) {
      this.type = type
      if (type === 2) {
        console.log('item', item.shield_secondary_url)
        this.title = item.title
        this.id = item.id
        this.linkarr = []
        if (item.shield_secondary_url !== null) {
          this.shield_secondary_url = []
        }
        let arr = []
        if (item.shield_region.length !== 0) {
          arr = JSON.parse(item.shield_region)
          this.$refs.tree.setCheckedKeys(arr)
        }
        this.selectedNodes = arr
        item.secondary_url.forEach((item, index) => {
          this.linkarr.push({
            link: item
          })
        })
        if (item.shield_secondary_url.length !== 0) {
          item.shield_secondary_url.forEach((item, index) => {
            this.shield_secondary_url.push({
              link: item
            })
          })
        } else {
          this.shield_secondary_url = [
            {
              link: ''
            }
          ]
        }

        console.log('this.linkarr', this.linkarr)
      }
    },
    copr(type) {
      if (type === 1) {
        this.linkarr.push({
          link: ''
        })
      } else if (type === 2) {
        this.shield_secondary_url.push({
          link: ''
        })
      }
    },
    delterr(index, type) {
      if (type === 1) {
        this.linkarr.splice(index, 1)
      } else if (type === 2) {
        this.shield_secondary_url.splice(index, 1)
      }
    },
    sumbit() {
      if (this.title === '') {
        this.$message.error('请输入二次跳转标题')
        return
      }
      const bool = this.linkarr.every((item, index, array) => {
        return item.link !== ''
      })
      if (bool === false) {
        this.$message.error('请填写地址')
        return
      }
      if (this.selectedNodes.length !== 0) {
        const bool = this.shield_secondary_url.every((item, index, array) => {
          return item.link !== ''
        })
        if (bool === false) {
          this.$message.error('请填写屏蔽地址')
          return
        }
      }
      this.chaunlinkarr = []
      let shield_secondary_url = []
      const shield_region = this.selectedNodes.length === 0 ? [] : this.selectedNodes
      console.log('shield_region:', shield_region)
      this.chaunlinkarr = this.linkarr.map(v => v.link)
      shield_secondary_url = this.shield_secondary_url.map(v => v.link)
      console.log('this.chaunlinkarr', this.chaunlinkarr)
      // if (this.selectedNodes.length === 0) {
      //   shield_secondary_url = []
      // }
      if (this.type === 1) {
        secondaryJumpcreate({
          title: this.title,
          secondary_url: this.chaunlinkarr,
          shield_secondary_url: shield_secondary_url,
          shield_region: shield_region
        }).then(res => {
          if (res.code === 200) {
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.$emit('updata')
            console.log('成功')
          }
        })
      } else {
        secondaryJumpupdate({
          id: this.id,
          title: this.title,
          secondary_url: this.chaunlinkarr,
          shield_secondary_url: shield_secondary_url,
          shield_region: shield_region
        }).then(res => {
          if (res.code === 200) {
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.$emit('updata')
            console.log('成功')
          }
        })
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.insedswr {
  width: 700px;
}
.linkfw {
  max-height: 500px;
  overflow: auto;
}
</style>
